import Section from '../../../../mixins/Section'
import * as d3 from 'd3-selection'
import { easeBackOut } from 'd3-ease'
import 'd3-transition'
export default {
  mixins: [Section],
  name: 'homeView',
  data () {
    return {
    }
  },
  beforeRouteUpdate (to, from, next) {
    console.log('beforeRouteUpdate', to.params.cat_product)
    next()
  },
  mounted () {
    this.$nextTick(this.showLogos)
  },
  methods: {
    enter () {
    },
    leave (el, done) {
      d3.selectAll('.home-container p')
        .transition()
        .ease(easeBackOut)
        .duration(400)
        .delay((d, i) => i * 40)
        .style('opacity', '0')
    },
    showLogos () {
      if (d3.selectAll('.home-container p').size() > 0) {
        d3.selectAll('.home-container p')
          .transition()
          .ease(easeBackOut)
          .duration(400)
          .delay((d, i) => i * 40)
          .style('opacity', '1')
      } else {
        setTimeout(this.showLogos, 20)
      }
    }
  }
}
